

import { Card, LinearProgress, Link, Paper, Typography } from "@mui/material";
import { Grid } from "@mui/system";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";

const AddReceiptsUploadFile = ({ isDragging, setIsDragging, handleFileDrop, handleFileUpload, uploadedFiles, handleRemoveFile }: any) => {
  return (
    <>
      <Grid container spacing={2} mt={2}> 
        <Typography>Please upload your receipt file</Typography>
        <Grid size={12}>
          <Card sx={{ marginTop: "16px", border: "none", borderRadius: 0, boxShadow: "none" }}>
            <Paper
              sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: 2,
              padding: 4,
              backgroundColor: isDragging ? "#f3e5f5" : "rgba(156, 39, 176, 0.04)",
              border: isDragging ? "1px dashed #9C27B0" : "1px dashed #cacacaff",
              pointerEvents: "auto",
              cursor: "pointer",
              }}
              onDragOver={(event) => {
                event.preventDefault();
                setIsDragging(true);
              }}
              onDragLeave={() => setIsDragging(false)}
              onDrop={handleFileDrop}
            >
              <UploadFileIcon color="secondary" fontSize="large" />
              <Typography
                component="label"
                sx={{ display: "flex", gap: 1, cursor: "pointer" }}
              >
                <Typography
                  color="secondary"
                  sx={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  Click to upload
                </Typography>
                <input
                  data-tracker="113"
                  type="file"
                  multiple
                  accept=".csv"
                  style={{ display: "none" }}
                  onChange={(event) => {
                    handleFileUpload(event);
                    event.target.value = ''; // Clear the input value to allow re-uploading the same file
                  }}
                />
                or drag and drop
              </Typography>
              <Typography sx={{ color: "#9e9e9e" }}>
                CSV (max. 5MB)
              </Typography>
            </Paper>
            {uploadedFiles?.length > 0 &&
              uploadedFiles?.map((file: any, index: any) => (
                <Card
                  key={index}
                  sx={{
                    padding: "8px 16px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "16px",
                  }}
                >
                  <div>
                    <Typography sx={{ fontWeight: "500" }}>
                      {file.file.split("/").pop()}
                    </Typography>
                    <Typography sx={{ paddingBottom: "4px" }}>
                      {(file.size / 1024).toFixed(2)} KB • {file.status}
                    </Typography>
                    <LinearProgress
                      color="secondary"
                      variant="determinate"
                      value={file.progress}
                    />
                  </div>
                  <CloseIcon
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleRemoveFile(index)}
                  />
                </Card>
              ))}
          </Card>

          <Typography mt={2}>Want to see the correct format first? <Link color="secondary" href="#">Download our sample file.</Link></Typography>
        </Grid>
      </Grid>
    </>
  )
}

export default AddReceiptsUploadFile
